<template>
  <div style="display:inline-block">
    <span style="margin-right:16px">{{ option.fileName }}</span>
    <a style="margin-right:16px" @click="downLoad(option)">下载</a>
    <a style="margin-right:16px" v-if="isReview(option.filePath)" @click="preview(option)">预览</a>
    <pre-view ref="viewModal" :preViewImgUrl="option.reviewUrl" :preViewFileUrl="option.reviewUrl"></pre-view>
  </div>
</template>

<script>
import preView from '@/components/PreView/PreView.vue'
import { downLoadFile } from '@/api/download'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'DownLoadVue',
  props: ['option'],
  components: {
    preView
  },
  computed: {
    ...mapGetters(['isReview']),
    info () {
      return this.$store.state.user.info
    }
  },
  data () {
    return {
      preViewUrl: ''
    }
  },
  methods: {
    ...mapActions(['pushDownloadFile', 'removeDownloadFile']),
    preview (model) {
      // console.log('modeloooooooooooo', model)
      // this.$refs['viewModal'].handleView(model)
      window.open(
        `${(this.$sysInfo.previewUrl)}` +
          model.url +
          `&fileName=${model.filePath}` +
          `&account=${this.info.account}` +
          `&token=${this.info.token}` +
          '&jwtToken=' +
          this.$store.state.user.token
      )
    },
    downLoad (item) {
      this.pushDownloadFile(item)
      downLoadFile(item.url).then(res => {
        this.removeDownloadFile(item)
        if (!res) {
          return
        }
        const blob = new Blob([res])
        const downloadElement = document.createElement('a') // 创建下载的链接
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = item.fileName // 下载后的文件名
        document.body.appendChild(downloadElement)
        downloadElement.click() // 下载
        document.body.removeChild(downloadElement) // 下载完成 移除 a
        window.URL.revokeObjectURL(href) // 释放blob对象
      })
    }
  }
}
</script>

<style scoped>
</style>
